import { render, staticRenderFns } from "./OnCallCareApp.vue?vue&type=template&id=af6bdecc&scoped=true"
import script from "./OnCallCareApp.vue?vue&type=script&lang=js"
export * from "./OnCallCareApp.vue?vue&type=script&lang=js"
import style0 from "./OnCallCareApp.vue?vue&type=style&index=0&id=af6bdecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6bdecc",
  null
  
)

export default component.exports